import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { TextField, makeStyles } from "@material-ui/core";
import { selectAddress, set } from "./addressSlice";
import { selectLanguage } from "../language/languageSlice";

const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(1),
      width: "100%",
      "&:hover": {
        boxShadow: "0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23)",
      },
      transition: "box-shadow 0.75s",
    },
  },
}));

export function Address() {
  const classes = useStyles();
  const addressValue = useSelector(selectAddress);
  const language = useSelector(selectLanguage);
  const dispatch = useDispatch();
  // const [incrementAmount, setIncrementAmount] = useState("2");

  return (
    <form className={classes.root} noValidate autoComplete="off">
      <TextField
        required
        id="input-address"
        label={
          language !== undefined
            ? language === "TH"
              ? "ที่อยู่สำหรับติดต่อกลับ"
              : "Contact Address"
            : "Contact Address"
        }
        placeholder={
          language !== undefined
            ? language === "TH"
              ? "ที่อยู่"
              : "Please fill Address"
            : "Please fill Address"
        }
        color="secondary"
        variant="outlined"
        rows={5}
        value={addressValue}
        multiline
        onChange={(e) => {
          if (e.target.value.length <= 1000) {
            dispatch(set(e.target.value));
          }
        }}
      />{" "}
    </form>
  );
}
